<div class="sidebar" [ngClass]="{ 'sidebar-collapsed': collapsed() }">
  <!-- Header Section -->
  <div class="sidebar-header flex flex-col items-start gap-4 w-full">
    @if (collapsed()) {
    <img
      src="/assets/icons/haulverse-icon.svg"
      alt="Haulverse Logo"
      class="logo"
    />
    } @else {
    <!-- Logo Row -->
    <span class="logo-text brand-gradient">Haulverse</span>
    
    <!-- Company Name Row -->
    <div
      class="flex items-center justify-center rounded-xl bg-secondary px-3 py-2 w-full"
    >
      <app-text class="text-primary" weight="bold">{{ fleetName() }}</app-text>
    </div>

    }

    <!-- Notifications (S3) -->
    <app-notification-bell placement="sidebar" [collapsed]="collapsed()" class="w-full" />
  </div>

  <!-- Main Navigation -->
  <nav class="nav-main">
    @for (item of navService.topNavItems(); track item.label) {
    @if (item.section && !collapsed()) {
    <div class="px-3 pt-3 pb-1 text-[10px] font-bold uppercase tracking-wider text-muted-foreground/60 select-none">
      {{ item.section }}
    </div>
    }
    <a
      [routerLink]="item.route"
      routerLinkActive="active"
      class="nav-item"
      [title]="collapsed() ? item.label : ''"
    >
      <lucide-icon [name]="item.icon" class="nav-icon"></lucide-icon>
      <span class="nav-label">{{ item.label }}</span>
      @if (item.badge && !collapsed()) {
      <span class="nav-badge">{{ item.badge }}</span>
      }
    </a>
    }
  </nav>

  <!-- Footer Section -->
  <div class="sidebar-footer">
    <nav class="nav-bottom">
      <div class="nav-item nav-item-centered cursor-pointer" (click)="toggleTheme()" tabindex="0" (keydown.enter)="toggleTheme()" [title]="collapsed() ? 'Toggle Theme' : ''">
        <div class="nav-icon toggle-wrapper flex items-center justify-center">
          <app-toggle 
            [ngModel]="isDarkMode()" 
            (ngModelChange)="toggleTheme()" 
            (click)="$event.stopPropagation()"
            iconOn="sun"
            iconOff="moon"
          />
        </div>
        <span class="nav-label">Dark Mode</span>
      </div>

      @for (item of navService.bottomNavItems(); track item.label) { @if
      (item.route) {
      <a
        [routerLink]="item.route"
        routerLinkActive="active"
        class="nav-item nav-item-centered"
        [title]="collapsed() ? item.label : ''"
      >
        <lucide-icon [name]="item.icon" class="nav-icon"></lucide-icon>
        <span class="nav-label">{{ item.label }}</span>
      </a>
      } @else if (item.handler) { @if (collapsed()) {

      <app-button
        (click)="item.handler()"
        [iconOnly]="true"
        icon="{{ item.icon }}"
        class="w-full nav-item-btn"
      />

      } @else {
      <app-button
        (click)="item.handler()"
        icon="{{ item.icon }}"
        class="w-full"
      >
        <span class="nav-label">{{ item.label }}</span>
      </app-button>
      } } }
    </nav>

    <!-- Collapse Toggle -->
    <div class="collapse-toggle flex items-center justify-center w-full mt-2">
      @if (collapsed()) {
      <app-button
        variant="ghost"
        (click)="toggleCollapse()"
        [iconOnly]="true"
        [icon]="'chevrons-right'"
        class="w-full nav-item-btn"
      />
      } @else {
      <app-button
        variant="ghost"
        (click)="toggleCollapse()"
        [icon]="'chevrons-left'"
        class="w-full"
      >
        <span class="nav-label">Collapse</span>
      </app-button>
      }
    </div>

    <!-- Copyright -->
    @if (!collapsed()) {
    <div class="mt-4 pt-2 border-t border-border w-full flex flex-col items-center">
      <app-text size="xs" class="text-[10px] text-muted-foreground/60">&copy; {{ currentYear }} Haulverse Inc.</app-text>
      <app-text size="xs" class="text-[9px] text-muted-foreground/40 mt-0.5">All rights reserved.</app-text>
    </div>
    }
  </div>
</div>
